
export const optionsNewStatus = [
	{
		name: 'Aprovação de Crédito',
		value: 'CreditApproval'
	},
	{
		name: 'Aprovação de Compliance',
		value: 'ComplianceApproval'
	},
	{
		name: 'Aprovação de Instrumento',
		value: 'InstrumentApproval'
	},
	{
		name: 'Validação de Assinaturas',
		value: 'SignaturesValidation'
	},
	{
		name: 'Coleta de assinaturas',
		value: 'Signatures'
	},
	{
		name: 'Encerrado',
		value: 'Finished'
	},
	{
		name: 'Cancelada',
		value: 'Canceled'
	},
	{
		name: 'Aguardando Liquidação',
		value: 'WaitLiquidation'
	},
	{
		name: 'Liquidação',
		value: 'Liquidation'
	},
	{
		name: 'Liquidação Manual',
		value: 'ManualLiquidation'
	},
	{
		name: 'Garantia',
		value: 'Warranty'
	},	
	{
		name: 'Revisão de Pagamento',
		value: 'PaymentRevision'
	},
	{
		name: 'Rascunho',
		value: 'Draft'
	},
	{
		name: 'Reprovado',
		value: 'Disapproved',
	},
	{
		name: 'Revisão',
		value: 'Revision'
	}
];